import { germanLang } from './../utils/languageFiles';
import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { englishLang, ILanguage } from '../utils/languageFiles';

export type Languages = 'de' | 'en';
export interface SettingsState {
  darkMode: boolean;
  language: Languages;
  languageFile: ILanguage;
  height: string | null;
}

const INITIAL_STATE: SettingsState = {
  darkMode: false,
  language: 'en',
  languageFile: englishLang,
  height: null,
};

const { actions, reducer } = createSlice({
  name: 'settings',
  initialState: INITIAL_STATE,
  reducers: {
    setAllSettings: (
      state: SettingsState,
      action: PayloadAction<SettingsState>
    ) => {
      state.darkMode = action.payload.darkMode;
      state.language = action.payload.language;
      state.languageFile = action.payload.languageFile;
      state.height = action.payload.height;
    },
    setDarkMode: (state: SettingsState, action: PayloadAction<boolean>) => {
      state.darkMode = action.payload;
    },
    setLanguage: (state: SettingsState, action: PayloadAction<Languages>) => {
      state.language = action.payload;
      state.languageFile = action.payload === 'de' ? germanLang : englishLang;
    },
    setHeight: (state: SettingsState, action: PayloadAction<string>) => {
      state.height = action.payload;
    },
  },
});

const getSettingsState = (state: any): SettingsState => state.settings;

const getAllSettings = createSelector(
  getSettingsState,
  (settings: SettingsState) => settings
);

const getLanguage = createSelector(
  getSettingsState,
  (settings: SettingsState) => settings.languageFile
);

export const selectors = {
  getAllSettings,
  getLanguage,
};

export const { setAllSettings, setLanguage, setDarkMode, setHeight } = actions;

export default reducer;
